import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const UpdateStudentEnrollmentMutation = graphql.persisted(
  "UpdateStudentEnrollment",
  graphql(`
    mutation UpdateStudentEnrollment(
      $studentEnrollmentId: ID!
      $enrollmentKind: String
      $gradeLevel: String
      $needsReview: Boolean
      $startsOn: ISO8601Date
      $tuitionOptionKey: String
    ) {
      updateStudentEnrollment(input: {
        studentEnrollmentId: $studentEnrollmentId
        enrollmentKind: $enrollmentKind
        gradeLevel: $gradeLevel
        needsReview: $needsReview
        startsOn: $startsOn
        tuitionOptionKey: $tuitionOptionKey
      }) {
        studentEnrollment {
          id
          state
          enrollmentKind
          gradeLevel
          needsReview
          startsOn
          tuitionOptionKey
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { UpdateStudentEnrollmentMutation };

export function useUpdateStudentEnrollment() {
  return useMutation(UpdateStudentEnrollmentMutation);
}
